import WTooltip from './tooltip.vue';
import WPreview from './preview-value.vue';
import WInput from './input.vue';
import WLabel from './label.vue';
import WTextarea from './textarea.vue';
import WCheckbox from './checkbox.vue';
import WRadio from './radio.vue';
import WError from './error.vue';
import WWarning from './warning.vue';
import WButton from './button.vue';
import WPagination from './pagination.vue';
import WSelect from './select.vue';
import WVueSelect from './vue-select.vue';
import WPkdSelect from './pkd-select.vue';
import WPkdTable from './pkd-table.vue';
import WDatepicker from './datepicker.vue';
import WModal from './modal.vue';
import WCrossedOut from './crossed-out.vue';
import WAutoText from './auto-text.vue';
import WAlert from './alert.vue';
import WAddRow from './add-row.vue';
import WRowButtons from './row-buttons.vue';
import WTableCell from './table-cell.vue';
import WLpCell from '../components/lp-cell.vue';
import WFormTable from '../components/form-table.vue';
import WSchemaTable from '../components/schema-table.vue';
import WThead from '../components/thead.vue';
import WTh from '../components/th.vue';
import WTbody from '../components/tbody.vue';
import WTblock from '../components/tblock.vue';
import WScrollspy from '../components/scrollspy.vue';
import WSpoiler from '../components/spoiler.vue';
import WRadioList from './radio-list.vue';
import WSwitch from './switch.vue';
import WDescription from './description.vue';
import WBlocker from './blocker.vue';
import WJarvis from './jarvis.vue';

//from bootstrap4-components
import WTercPicker from './tercPicker.vue';
import WSimcPicker from './simcPicker.vue';
import WUlicPicker from './ulicPicker.vue';
import WTerytPicker from './terytPicker.vue';

//shared components
import WStatement from './shared/Statement.vue';
import WStatements from './shared/Statements.vue';
import WAddress from './shared/Address.vue';
import WLegalForm from './shared/LegalForm.vue';
import WSphere from './shared/Sphere.vue';
import WFormDevTools from './shared/FormDevTools.vue';

//section
import WSection from './section.vue';
import WNextNumber from './next-number.vue';

// UWAGA: koniecznie zaktualizaować również formComponentsList.js - listę komponentów do buildera
export const components = {
  WJarvis,
  WInput,
  WLabel,
  WPreview,
  WTextarea,
  WPagination,
  WSelect,
  WDatepicker,
  WModal,
  WRadio,
  WTooltip,
  WError,
  WWarning,
  WAddRow,
  WRowButtons,
  WButton,
  WCheckbox,
  WCrossedOut,
  WAutoText,
  WAlert,
  WScrollspy,
  WSpoiler,
  WRadioList,
  WSwitch,
  WVueSelect,
  WPkdSelect,
  WPkdTable,
  WDescription,
  WBlocker,

  WLpCell,
  WFormTable,
  WSchemaTable,
  WTableCell,
  WThead,
  WTh,
  WTblock,
  WTbody,

  WTercPicker,
  WSimcPicker,
  WUlicPicker,
  WTerytPicker,

  WStatement,
  WStatements,
  WAddress,
  WLegalForm,
  WSphere,
  WFormDevTools,

  WSection,
  WNextNumber
};

export function registerComponents(Vue, registerLog) {
  for (var name in components) {
    if (registerLog) {
      console.time('register ' + name);
      Vue.component(name, components[name]);
      console.timeEnd('register ' + name);
    } else {
      Vue.component(name, components[name]);
    }
  }
}

export default components;
